import React, { useMemo } from 'react';
import useCustomerEmails from '../hooks/use-customer-emails';
import useOneWayIn from '../../hooks/use-one-way-in';
import { useParams } from 'react-router-dom';
import { PageParams } from '../types/PageParams';
import EmailComposer from '../components/customer-communication/EmailComposer';
import { useAuth } from 'src/features/authorization';
import NoAccess from 'src/components/NoAccess/NoAccess';
import { useTranslation } from 'react-i18next';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import '../styles/CustomerCommunication.scss';
import EmailThread from '../components/customer-communication/EmailThread';
import Divider from 'src/components/Divider';
import useCustomerEmail from '../hooks/use-customer-email';
import { Heading } from '@innovationnorway/cl-react';

const CustomerCommunication: React.FC = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInOpportunityById, oneWayInGroupedFormWOEnrollmentsQuery } = useOneWayIn(formId);
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { threads, isInitialLoading: isLoadingThreads } = useCustomerEmails(
    oneWayInOpportunityById.data?.id ?? '',
  );
  const { checkAccess } = useAuth();
  const { read, write } = checkAccess('OneWayInCustomerCommunication');

  const firstThread = useMemo(() => threads?.at(0), [threads]);
  const { details, isLoading: isLoadingEmails } = useCustomerEmail(firstThread?.numericId, formId);

  if (!read) {
    return <NoAccess />;
  }

  if (
    oneWayInOpportunityById.isInitialLoading ||
    oneWayInGroupedFormWOEnrollmentsQuery.isInitialLoading ||
    isLoadingThreads ||
    (threads?.length && isLoadingEmails)
  ) {
    return <LoadingPage />;
  }

  return (
    <div className="stack">
      <Heading level={2}>{tOneWayIn('communication.sendEmailToCustomer')}</Heading>
      <section aria-label="Samtaleutdrag">
        {
          <div className="customer-communication">
            <EmailThread key={firstThread?.numericId} emails={details?.emails} />
            {write && (
              <div className="customer-communication-composer">
                <Divider className="customer-communication__divider" aria-hidden="true" />
                <EmailComposer
                  formId={formId}
                  contactInfo={oneWayInGroupedFormWOEnrollmentsQuery.data?.kontakt}
                  threadId={firstThread?.numericId}
                  opportunity={oneWayInOpportunityById.data}
                />
              </div>
            )}
          </div>
        }
      </section>
    </div>
  );
};

export default CustomerCommunication;
